import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { PrelaunchGate } from '@/components/common/PrelaunchGate'
import './index.css'

// Import supabase to trigger configuration logging on startup
// This initializes and validates all environment configurations
import '@/lib/supabase'

// Startup banner
const APP_VERSION = import.meta.env.VITE_APP_VERSION || '0.1.0'
const APP_ENV = import.meta.env.VITE_APP_ENV || 'development'

console.log('')
console.log('========================================')
console.log(`  Exercise Toolbox v${APP_VERSION}`)
console.log(`  Environment: ${APP_ENV}`)
console.log('========================================')
console.log('')

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <PrelaunchGate>
          <App />
        </PrelaunchGate>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
)
